import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { TAvailabilityPayload } from '@/services/staff';

import { notifyMeta } from '@/lib/notify';
import { CONCIERGE_KEYS, STAFF_KEYS } from '@/constants/queryKeys';
import { errorUtils } from '@/services/errors';
import { staffService } from '@/services/staff';

const setStaffAvailability = async (payload: TAvailabilityPayload) => errorUtils.unwrap(await staffService.setAvailability(payload));

const useSetStaffAvailability = () => {
  const queryClient = useQueryClient();

  return useMutation<string, Error, TAvailabilityPayload>({
    meta: notifyMeta('staffAvailability'),
    mutationKey: ['staff', 'availability'],
    mutationFn: setStaffAvailability,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: STAFF_KEYS.directory() });
      await queryClient.invalidateQueries({ queryKey: CONCIERGE_KEYS.root });
    },
  });
};

export {
  useSetStaffAvailability,
};
